export { ModalQRPreview } from "./ModalQRPeview";
